import GoogleMap from './google-map'

export default {
    googleMap: new GoogleMap(),
    ajaxurl: window.ajaxurl || '/wp/wp-admin/admin-ajax.php',
    searchQueryTypes: [
        {
            slug: 'all',
            name: 'Alla',
        },
        {
            slug: 'pages',
            name: 'Sidor',
        },
        {
            slug: 'news',
            name: 'Nyheter',
        },
        {
            slug: 'documents',
            name: 'Dokument',
            criteria: [
                {
                    slug: 'projekts',
                    name: 'På projekt',
                },
                {
                    slug: 'objekts',
                    name: 'På lägenheter',
                },
            ],
        },
        {
            slug: 'projekts',
            name: 'Projekt',
            criteria: [
                {
                    slug: 'Namn',
                    name: 'Namn',
                },
                {
                    slug: 'Arkitekt',
                    name: 'Arkitekt',
                },
                {
                    slug: 'OmradeNamn',
                    name: 'Stad',
                },
            ],
        },
        // {
        //   slug: "objekts",
        //   name: "Lägenheter",
        //   criteria: [
        //     {
        //       slug: "Namn",
        //       name: "Namn"
        //     },
        //     {
        //       slug: "OmradeNamn",
        //       name: "Stad"
        //     },
        //     {
        //       slug: "ContainingProjekt",
        //       name: "Projektnamn"
        //     },
        //   ]
        // },
        {
            slug: "personnel",
            name: "Personal"
        }
    ]
};
